<mat-card *ngFor="let element of response.dataSourceCard" class="card">
  <mat-card-content>
     
    <div class="group">
      <ng-container *ngFor="let name of response.displayedReference; let i = index">    
        <section *ngIf="response.groupCard[i] === 1">
          <p>{{response.nameHeader[i]}}</p>
          <ng-container *ngIf="response.typeData[i] === 'string'">
            <p>{{element[name]}}</p>
          </ng-container>
          <ng-container *ngIf="response.typeData[i] === 'decimal'">
            <p>{{element[name] | currency : 'R$'}}</p>
          </ng-container>
        </section>
      </ng-container>
    </div>

    <div class="group">
      <ng-container *ngFor="let name of response.displayedReference; let i = index">    
        <section *ngIf="response.groupCard[i] === 2">
          <p>{{response.nameHeader[i]}}</p>
          <ng-container *ngIf="response.typeData[i] === 'string'">
            <p>{{element[name]}}</p>
          </ng-container>
          <ng-container *ngIf="response.typeData[i] === 'decimal'">
            <p>{{element[name] | currency : 'R$'}}</p>
          </ng-container>
        </section>
      </ng-container>
    </div>

    <div class="group">
      <ng-container *ngFor="let name of response.displayedReference; let i = index">    
        <section *ngIf="response.groupCard[i] === 3">
          <p>{{response.nameHeader[i]}}</p>
          <ng-container *ngIf="response.typeData[i] === 'string'">
            <p>{{element[name]}}</p>
          </ng-container>
          <ng-container *ngIf="response.typeData[i] === 'decimal'">
            <p>{{element[name] | currency : 'R$'}}</p>
          </ng-container>
        </section>
      </ng-container>
    </div>

    <div class="group">
      <ng-container *ngFor="let name of response.displayedReference; let i = index">    
        <section *ngIf="response.groupCard[i] === 4">
          <p>{{response.nameHeader[i]}}</p>
          <ng-container *ngIf="response.typeData[i] === 'string'">
            <p>{{element[name]}}</p>
          </ng-container>
          <ng-container *ngIf="response.typeData[i] === 'decimal'">
            <p>{{element[name] | currency : 'R$'}}</p>
          </ng-container>
        </section>
      </ng-container>
    </div>

  </mat-card-content>

  <mat-card-actions>
    <div class="actions__button">
      <ng-container *ngFor="let name of response.displayedReference; let i = index">   

        <ng-container *ngIf="name === 'actions'"> 
          <ng-container *ngFor="let item of response.buttons;">
            <button 
              *ngIf="!item.hide" 
              mat-button 
              [disabled]="item.disabled" 
              [matTooltip]="item.tooltip"
            >
              <img src="../../../assets/icons/{{item.icon}}.svg">
            </button>
          </ng-container>
        </ng-container>

      </ng-container>
    </div>
  </mat-card-actions>
</mat-card>